import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';

import { LayoutComponent } from './layout/layout.component';
import { QbPromotionalCodeModalComponent } from './components/promotional-code-modal/promotional-code-modal.component';
import { IonicModule } from '@ionic/angular';
import { QbHomeItaComponentsLibModule } from '@fwmovilidad/qb-home-ita-components-lib';
import { QbExitIntentModalComponent } from './components/exit-intent-modal/exit-intent-modal.component';
import { QbTrackErrorsDirective } from './directives/trackErrorsDirective.directive';

const COMPONENTS = [LayoutComponent, QbPromotionalCodeModalComponent, QbExitIntentModalComponent];

const MODULES = [
  CommonModule,
  RouterModule,
  IonicModule,
  FormsModule,
  ReactiveFormsModule,
  TranslateModule,
  QbHomeItaComponentsLibModule,
];

const DIRECTIVES = [QbTrackErrorsDirective];

@NgModule({
  imports: [...MODULES],
  declarations: [...COMPONENTS, ...DIRECTIVES],
  exports: [...COMPONENTS, ...DIRECTIVES, ...MODULES],
  providers: [TranslatePipe],
})
export class SharedModule {}
